import React, { useState } from "react";
import "./Header.css";

import { Link } from "react-router-dom";
import { Drawer } from "antd";
import {
  DoubleRightOutlined,
  MenuOutlined,
  CloseCircleOutlined,
  CaretDownOutlined,
  CaretUpOutlined,
} from "@ant-design/icons";

import Img1 from "../Img/Header Icon.png";
import Img2 from "../Img/okkk-removebg-preview.png";
import Icon1 from "../Icon/facebook (1).png";
import Icon2 from "../Icon/social.png";
import Icon3 from "../Icon/linkedin (1).png";
import Icon4 from "../Icon/github (1).png";

export default function Header() {
  const [open, setOpen] = useState(false);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const [isActive, setIsActive] = useState(false);

  const toggleDropdown = () => {
    setIsActive(!isActive);
  };

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown2 = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  // Handle hover to show/hide dropdown items
  const handleDropdownHover = () => {
    setIsActive(true);
  };

  const handleDropdownLeave = () => {
    setIsActive(false);
  };

  return (
    <div className="Header-Body">
      <Link className="Header-Link1" to="/">
        <img className="Header-Icon" src={Img1} alt="Img" />
      </Link>

      <div className="Header-Box">
        <Link className="Header-Link2" to="/">
          <img src={Img2} className="Header-Icon2" alt="" />
          <p className="Header-Text">Home</p>
        </Link>
        <Link className="Header-Link2" to="/service">
          <img src={Img2} className="Header-Icon2" alt="" />
          <p className="Header-Text">Service</p>
        </Link>
        <Link className="Header-Link2" to="/blog">
          <img src={Img2} className="Header-Icon2" alt="" />
          <p className="Header-Text">Blog</p>
        </Link>
        <div
          className={`dropdown ${isActive ? "active" : ""}`}
          onMouseEnter={handleDropdownHover}
          onMouseLeave={handleDropdownLeave}
        >
          <img src={Img2} className="Header-Icon2" alt="" />
          <p className="Header-Text">Pages</p>

          <span className="left-icon"></span>
          <span className="right-icon"></span>
          <div className="items">
            <Link href="#" style={{ "--i": 1 }} to="/about-us">
              <span></span>About Me
            </Link>

            <Link href="#" style={{ "--i": 2 }} to="/project">
              <span></span> Project
            </Link>

            <Link href="#" style={{ "--i": 3 }} to="/game">
              <span></span> Game's
            </Link>

            <Link href="#" style={{ "--i": 4 }} to="/faq">
              <span></span> FAQ
            </Link>

            <Link href="#" style={{ "--i": 5 }} to="*">
              <span></span> 404 Page
            </Link>
          </div>
        </div>
        <Link className="Header-Link2" to="/contact">
          <img src={Img2} className="Header-Icon2" alt="" />
          <p className="Header-Text">Contact</p>
        </Link>
      </div>

      <Link className="Header-Link-Button" to="/contact">
        Hire Me
        <DoubleRightOutlined />
      </Link>

      <button className="Header-Menu-Button" onClick={showDrawer}>
        <MenuOutlined />
      </button>

      <Drawer
        placement="right"
        closable={false}
        onClose={onClose}
        visible={open}
        key="right"
        style={{ background: "#2a3548" }}
      >
        <div className="Header-Drawer">
          <div className="Header-Drawer-Box">
            <button className="Header-Menu-Button2" onClick={onClose}>
              <CloseCircleOutlined />
            </button>
          </div>

          <div className="Header-Drawer-Div">
            <Link className="Header-Drawer-Link" to="/">
              HOME
            </Link>
            <Link className="Header-Drawer-Link" to="/service">
              SERVICES
            </Link>
            <Link className="Header-Drawer-Link" to="/blog">
              BLOG
            </Link>
            <div className="Header-Drawer-Link2" onClick={toggleDropdown2}>
              <p>PAGES</p>
              {isDropdownOpen ? <CaretUpOutlined /> : <CaretDownOutlined />}
            </div>

            {isDropdownOpen && (
              <div className="Header-Drawer-LinkDiv">
                <Link to="/about-us" className="Header-Drawer-Link">
                  About Me
                </Link>

                <Link to="/project" className="Header-Drawer-Link">
                  Project
                </Link>

                <Link to="/game" className="Header-Drawer-Link">
                Game's
                </Link>

                <Link to="/faq" className="Header-Drawer-Link">
                  FAQ
                </Link>

                <Link to="*" className="Header-Drawer-Link">
                  404 Page
                </Link>
              </div>
            )}

            <Link className="Header-Drawer-Link2" to="/contact">
              CONTACT
            </Link>
          </div>

          <div className="Header-Drawer-Div2">
            <a
              href="https://www.facebook.com/tasnimSakash/"
              target="blank"
              className="Header-Drawer-A"
            >
              <img className="Header-Drawer-Icon" src={Icon1} alt="" />
            </a>

            <a
              href="https://www.instagram.com/tasnim_shahriar_akash?utm_source=qr%2F"
              target="blank"
              className="Header-Drawer-A"
            >
              <img className="Header-Drawer-Icon" src={Icon2} alt="" />
            </a>

            <a
              href="https://www.linkedin.com/in/tasnimsakash/"
              target="blank"
              className="Header-Drawer-A"
            >
              <img className="Header-Drawer-Icon" src={Icon3} alt="" />
            </a>

            <a
              href="https://github.com/akashsdk"
              target="blank"
              className="Header-Drawer-A"
            >
              <img className="Header-Drawer-Icon" src={Icon4} alt="" />
            </a>
          </div>
        </div>
      </Drawer>
    </div>
  );
}
